export const tableOptions = [
	{ value: 10, label: '10개씩 보기' },
  	{ value: 20, label: '20개씩 보기' },
  	{ value: 30, label: '30개씩 보기' },
];

export const signupOptions = [
	{ value: '정회원', label: '정회원' },
	{ value: '학생회원', label: '학생회원' },
	{ value: '특별회원', label: '특별회원' },
	{ value: '명예회원', label: '명예회원' },
];
export const PaymentOptions = [
	{ value: '0', label: '일시불' },
	{
		value: '2개월',
		label: '2',
	},
	{
		value: '3개월',
		label: '3',
	},
	{
		value: '4개월',
		label: '4',
	},
	{
		value: '5개월',
		label: '5',
	},
	{
		value: '6개월',
		label: '6',
	},
	{
		value: '7개월',
		label: '7',
	},
	{
		value: '8개월',
		label: '8',
	},
	{
		value: '9개월',
		label: '9',
	},
	{
		value: '10개월',
		label: '10',
	},
	{
		value: '11개월',
		label: '11',
	},
	{
		value: '12개월',
		label: '12',
	},
];
export const degreeOptions = [
	{ value: '박사', label: '박사' },
	{ value: '석사', label: '석사' },
	{ value: '학사', label: '학사' },
	{ value: '박사과정', label: '박사과정' },
	{ value: '석사과정', label: '석사과정' },
	{ value: '학사과정', label: '학사과정' },
];
export const yearOptions = new Array(100).fill(0).map((_, index) => ({
	value: String(2025 - index),
	label: String(2025 - index),
}));
export const positionOptions = [
	{ value: '교수', label: '교수' },
	{ value: '책임연구원', label: '책임연구원' },
	{ value: '선임연구원', label: '선임연구원' },
	{ value: '박사후연구원', label: '박사후연구원' },
	{ value: '학생연구원', label: '학생연구원' },
	{ value: '기타(직접입력)', label: '기타(직접입력)' },
];
export const monthOptions = [
	{ value: '1', label: '1' },
	{ value: '2', label: '2' },
	{ value: '3', label: '3' },
	{ value: '4', label: '4' },
	{ value: '5', label: '5' },
	{ value: '6', label: '6' },
	{ value: '7', label: '7' },
	{ value: '8', label: '8' },
	{ value: '9', label: '9' },
	{ value: '10', label: '10' },
	{ value: '11', label: '11' },
	{ value: '12', label: '12' },
];

export const daysOptions = new Array(31).fill(0).map((_, index) => ({
	value: String(index + 1),
	label: String(index + 1),
}));
export const emailOptions = [
	{ value: '직접입력', label: '직접입력' },
	{ value: 'naver.com', label: 'naver.com' },
	{ value: 'gmail.com', label: 'gmail.com' },
	{ value: 'hanmail.net', label: 'hanmail.net' },
	{ value: 'daum.net', label: 'daum.net' },
	{ value: 'nate.com', label: 'nate.com' },
	{ value: 'hotmail.com', label: 'hotmail.com' },
	{ value: 'yahoo.com', label: 'yahoo.com' },
	{ value: 'empas.com', label: 'empas.com' },
	{ value: 'korea.com', label: 'korea.com' },
	{ value: 'dreamwiz.com', label: 'dreamwiz.com' },
	{ value: 'lycos.co.kr', label: 'lycos.co.kr' },
	{ value: 'paran.com', label: 'paran.com' },
	{ value: 'freechal.com', label: 'freechal.com' },
	{ value: 'hanmir.com', label: 'hanmir.com' },
	{ value: 'hitel.net', label: 'hitel.net' },
	{ value: 'chol.com', label: 'chol.com' },
	{ value: 'netian.com', label: 'netian.com' },
	{ value: 'hanafos.com', label: 'hanafos.com' },
	{ value: 'orgio.net', label: 'orgio.net' },
	{ value: 'kornet.net', label: 'kornet.net' },
];
export const countryOptions = [
	'가나',
	'가이아나',
	'감비아',
	'건지 섬',
	'과들루프',
	'과테말라',
	'괌',
	'그레나다',
	'그리스',
	'그린란드',
	'기니',
	'기니비사우',
	'나미비아',
	'나우루',
	'나이지리아',
	'남극',
	'남수단',
	'남아프리카공화국',
	'네덜란드',
	'네덜란드령 안틸레스',
	'네팔',
	'노르웨이',
	'노퍽 섬',
	'누벨칼레도니',
	'뉴질랜드',
	'니우에',
	'니제르',
	'니카라과',
	'대한민국',
	'덴마크',
	'도미니카 공화국',
	'도미니카 연방',
	'독일',
	'동티모르',
	'라오스',
	'라이베리아',
	'라트비아',
	'러시아',
	'레바논',
	'레소토',
	'레위니옹',
	'루마니아',
	'룩셈부르크',
	'르완다',
	'리비아',
	'리투아니아',
	'리히텐슈타인',
	'마다가스카르',
	'마르티니크',
	'마셜 제도',
	'마요트',
	'마카오',
	'마케도니아 공화국',
	'말라위',
	'말레이시아',
	'말리',
	'맨섬',
	'멕시코',
	'모나코',
	'모로코',
	'모리셔스',
	'모리타니',
	'모잠비크',
	'몬테네그로',
	'몬트세랫',
	'몰도바',
	'몰디브',
	'몰타',
	'몽골',
	'미국',
	'미국령 군소 제도',
	'미국령 버진아일랜드',
	'미얀마',
	'미크로네시아 연방',
	'바누아투',
	'바레인',
	'바베이도스',
	'바티칸 시국',
	'바하마',
	'방글라데시',
	'버뮤다',
	'베냉',
	'베네수엘라',
	'베트남',
	'벨기에',
	'벨라루스',
	'벨리즈',
	'보스니아 헤르체고비나',
	'보츠와나',
	'볼리비아',
	'부룬디',
	'부르키나파소',
	'부베 섬',
	'부탄',
	'북마리아나 제도',
	'불가리아',
	'브라질',
	'브루나이',
	'사모아',
	'사우디아라비아',
	'사우스조지아 사우스샌드위치 제도',
	'산마리노',
	'상투메 프린시페',
	'생피에르 미클롱',
	'서사하라',
	'세네갈',
	'세르비아',
	'세이셸',
	'세인트루시아',
	'세인트빈센트 그레나딘',
	'세인트키츠 네비스',
	'세인트헬레나',
	'소말리아',
	'솔로몬 제도',
	'수단',
	'수리남',
	'스리랑카',
	'스발바르 얀마옌',
	'스와질란드',
	'스웨덴',
	'스위스',
	'스페인',
	'슬로바키아',
	'슬로베니아',
	'시리아',
	'시에라리온',
	'신트마르턴',
	'싱가포르',
	'아랍에미리트',
	'아루바',
	'아르메니아',
	'아르헨티나',
	'아메리칸사모아',
	'아이슬란드',
	'아이티',
	'아일랜드',
	'아제르바이잔',
	'아프가니스탄',
	'안도라',
	'알바니아',
	'알제리',
	'앙골라',
	'앤티가 바부다',
	'앵궐라',
	'에리트레아',
	'에스토니아',
	'에콰도르',
	'에티오피아',
	'엘살바도르',
	'영국',
	'영국령 버진아일랜드',
	'영국령 인도양 지역',
	'예멘',
	'오만',
	'오스트레일리아',
	'오스트리아',
	'온두라스',
	'올란드 제도',
	'요르단',
	'우간다',
	'우루과이',
	'우즈베키스탄',
	'우크라이나',
	'왈리스 퓌튀나',
	'이라크',
	'이란',
	'이스라엘',
	'이집트',
	'이탈리아',
	'인도',
	'인도네시아',
	'일본',
	'자메이카',
	'잠비아',
	'저지 섬',
	'적도 기니',
	'조지아',
	'조선민주주의인민공화국',
	'조지아',
	'중앙아프리카공화국',
	'중화민국',
	'중화인민공화국',
	'지부티',
	'지브롤터',
	'짐바브웨',
	'차드',
	'체코',
	'칠레',
	'카메룬',
	'카보베르데',
	'카자흐스탄',
	'카타르',
	'캄보디아',
	'캐나다',
	'케냐',
	'코모로',
	'케이맨 제도',
	'코스타리카',
	'코코스 제도',
	'코트디부아르',
	'콜롬비아',
	'콩고 공화국',
	'콩고 민주 공화국',
	'쿠바',
	'쿠웨이트',
	'쿡 제도',

	'크로아티아',
	'크리스마스섬',
	'키르기스스탄',
	'키리바시',
	'키프로스',
	'타이',
	'타지키스탄',
	'탄자니아',
	'터크스 케이커스 제도',
	'터키',
	'토고',
	'토켈라우',
	'통가',
	'투르크메니스탄',
	'투발루',
	'튀니지',
	'트리니다드 토바고',
	'파나마',
	'파라과이',
	'파키스탄',
	'파푸아뉴기니',
	'팔라우',
	'팔레스타인',
	'페로 제도',
	'페루',
	'포르투갈',
	'포클랜드 제도',
	'폴란드',
	'푸에르토리코',
	'프랑스',
	'프랑스령 기아나',
	'프랑스령 남방 및 남극',
	'프랑스령 폴리네시아',
	'피지',
	'핀란드',
	'필리핀',
	'핏케언 제도',
	'허드 맥도널드 제도',
	'헝가리',
	'홍콩',
];
export const formattedCountryOptions = countryOptions.map((country) => ({
	value: country,
	label: country,
}));
